<template>
    <router-link :class="`list-group-item menu-list-item${draggedOver ? ' is-dragged-over' : ''}`" v-if="menuItem != null" :to="href" :tag="disableLink ? 'div' : 'a'" :disabled="disableLink">
        <div ref="dropItem" class="menu-label" :draggable="isDraggable" v-on:drag="onDrag" v-on:dragstart="onDragStart" v-on:dragover="onDragOver" v-on:dragend="onDragEnd">
            <span class="decorator" v-if="!disableDecorator">
                <slot name="Decorator">
                    <i class="fas fa-circle" :style="{ color:'#'+ menuItem.ColorCode }"></i>
                </slot>
            </span>
            <span class="title" :class="$route.name.toLowerCase()" >
                <slot name="Name">
                    {{ menuItem.name }}
                </slot>
            </span>
        </div>
        <slot name="Badge"></slot>
        <div v-if="isDroppable" v-on:dragleave="onDragLeave" v-on:dragover="onDragOver" @drop.prevent.stop="onDrop" class="list-group-item-dropzone"></div>
        <slot></slot>
    </router-link>
</template>

<script>
    import Vue from 'vue';
    import { HTTP } from "@/utils/http";
    import CustomLink from'@/components/common/CustomLink.vue';
    import BootstrapVue from 'bootstrap-vue';
    import { mapActions } from 'vuex';
    import EventBus from '@/eventbus';
    import Apis from '@/apis';
    Vue.use(BootstrapVue);

    export default {
        name: "MenuCard",
        components: { CustomLink },
        props: {
            menuItem: Object,
            href: { type: [String, Object], default: null },
            disableLink: { type: Boolean, default: false },
            isDraggable: Boolean,
            isDroppable: Boolean,
            disableDecorator: { type: Boolean, default: false },
            itemType: { type: String, default: null }
        },
        data() {
            return {
                clientX: 0,
                clientY: 0,
                draggedOver: false
            }
        },
        methods: {
            onDrop(e) {
                if(e.preventDefault) { e.preventDefault(); }
                if(e.stopPropagation) { e.stopPropagation(); }
                if (this.itemType === 'box') {
                    this.onBoxDrop();
                }
            },
            async onBoxDrop() {
                if (this.$store.state.dnd.type !== 'tracks') {
                    return;
                }

                const stationUid = this.$store.state.currentStationUid;
                const boxUid = this.menuItem.uid;
                const trackUids = this.$store.state.dnd.item.map(item => item.uid);

                try {
                    await this.$store.dispatch("Boxes/linkMultipleTrack",
                    {
                        stationUid: stationUid,
                        boxUid: boxUid,
                        trackUids:trackUids,
                        sourceStationUid: this.$route.params.stationUid
                    })
                    EventBus.$emit("onBoxTrackMoved");
                    // Update Target
                    if (boxUid)
                        this.$store.dispatch('refreshBoxStats', { stationUid, boxUid });
                    // Update Source
                    if (this.$route.params.boxUid)
                        this.$store.dispatch('refreshBoxStats', { stationUid, boxUid: this.$route.params.boxUid});
                    else
                        this.$store.dispatch('refreshBoxStats', { stationUid, reloadAll:true});
                    // this.menuItem.statistics.trackCount = response.data.dataItem.length
                    // this.$store.dispatch('loadStationBoxes', this.$store.state.currentStationUid);
                } catch (e) {
                    const errorMessage = e.response.data.errors[0].message;
                    // this.$store.dispatch('Toasts/addToast', {
                    //     title: 'Error',
                    //     message: errorMessage,
                    //     type: 'danger'
                    // });
                    // await this.$store.dispatch('notifications/create', {
                    //     notification: {
                    //         message: errorMessage,
                    //         icon: 'fa-times',
                    //         class: 'error'
                    //     }
                    // });
                }

            },
            onDragOver(e) {
                e.preventDefault();
                if (this.isDroppable) {
                    this.draggedOver = true;
                }
            },
            onDragLeave(e) {
                e.preventDefault();
                if (this.isDroppable) {
                    this.draggedOver = false;
                }
            },
            onDrag(e) {
                const { clientY, clientX } = e;

                if (clientY === this.clientY && clientX === this.clientX) {
                    return;
                }

                this.clientX = clientX;
                this.clientY = clientY;
                EventBus.$emit('drag', e);
            },
            onDragStart(e) {
              if (this.itemType === 'dayTemplate') {
                this.fetchDayTemplateConstraints()
              }
                //  /!\ Only for planning : start
                // Display indication for month drop zone
                const currentPath = this.$route.path;
                if (currentPath && currentPath.toLowerCase().includes('planning')) {
                    const monthDropZone = document.getElementById('month-drop-zone');
                    if (monthDropZone) {
                        monthDropZone.classList.add('drop-indication')
                    }
                }
                // Only for planning: end

                const placeholderDropZone = document.getElementById('placeholder__drag--zone');
                if (placeholderDropZone) {
                    placeholderDropZone.classList.add('placeholder__drag--zone-active')
                }
                // Fix for Firefox
                const $ghost = document.body.querySelector('#drag-ghost');
                $ghost.innerHTML = this.menuItem.name;
                e.dataTransfer.setDragImage($ghost, 0, 0);
                // e.currentTarget.classList.add('is-dragged');
                if (this.itemType === 'dayTemplate') {
                  this.$store.dispatch('Templates/setDraggedDayTemplateUid', this.menuItem.uid)
                }
                EventBus.$emit('dragStart', e, this.menuItem, this.itemType);
            },
            onDragEnd(e) {
                // /!\ Only if planning view
                const currentPath = this.$route.path;
                if (currentPath && currentPath.toLowerCase().includes('planning')) {
                    const monthDropZone = document.getElementById('month-drop-zone');
                    if (monthDropZone) {
                        monthDropZone.classList.remove('drop-indication')
                    }
                }
                // Only for planning: end

                const placeholderDropZone = document.getElementById('placeholder__drag--zone');
                if (placeholderDropZone) {
                    placeholderDropZone.classList.remove('placeholder__drag--zone-active')
                }
                // e.currentTarget.classList.remove('is-dragged');
                EventBus.$emit('dragEnd', e);
            },
            async fetchDayTemplateConstraints () {
              await this.$store.dispatch('Templates/fetchDayTemplateDetails', { stationUid: this.$store.state.currentStationUid, dayTemplateUid: this.menuItem.uid })
            }
        },
    }
</script>

<style lang="scss" scoped>
    .list-group-item {
        padding: 12px 10px;
        border-left: 0;
        border-right: 0;

        &:hover {
            text-decoration: none;
        }

        &.is-dragged-over {
            background-color: #f6f7f8;
        }

        &-dropzone {
            display: none !important;
            position: absolute !important;
            left: 0;
            top: 0;
            width: 100% !important;
            height: 100% !important;
            z-index: 10 !important;

            body.drag-active & {
                display: block !important;
            }
        }

        &:first-child {
            border-top: 0;
        }

        &:last-child {
            border-bottom: 0;
        }

        .menu-label {
            font-weight: 400;

            .title {
                overflow: hidden;
            }

            .decorator {
                margin-right: 10px;
            }
        }
    }

    .menu-label[draggable="true"] {
        cursor: grab;
    }
</style>

<style lang="scss">
    .list-group-item {
        .badge {
            > span {
                display: inline-block;
                vertical-align: middle;
                margin-top: 1px;
            }
        }
    }
</style>
